import React, { useState } from "react";
import { Formik } from "formik";
import SelectDropdown from "../../../../../components/common-components/selectDropdown";
import { FAMILY_MEMBER_HISTORY_STATUS } from "../Constants";
import Input from "../../../../../components/common-components/input/Input";
import Button from "../../../../../components/common-components/button/Button";
import { BUTTON_VARIANTS } from "../../../../../components/common-components/button/Constants";
import { v4 as uuidv4 } from 'uuid';
import ModalComponent from "../../../../../components/common-components/modal/ModalComponent";
import Checkbox from "../../../../../components/common-components/checkbox/Checkbox";

const FamilyMemberHistory = ({ open, onConfirm, close }) => {

    const validate = (values) => {

        const errors = {};

        if (values.fmh_Status.value === "Select Status") {
            errors.fmh_Status = "Status is required.";
        }

        if(!values.relationship || values.relationship.trim() === ""){
            errors.relationship = "Please provide relation ship to the subject."
        }

        if (!values.fmh_age || values.fmh_age.trim() ===""){
            errors.fmh_age = "Age is Required"
        }else if(isNaN(values.fmh_age) || Number(values.fmh_age)<=0){
            errors.fmh_age = "Please enter a valid age"
        }

        if (!values.fmh_reason || values.fmh_reason.trim() === ""){
            errors.fmh_reason = "Reason is required"
        }

        if(!values.fmh_condition){
            errors.fmh_condition = "Please provide the condition."
        }
        
        if (!values.fmh_date) {
            errors.fmh_date = "Date is required.";
        }
    
        if (!values.fmh_sex || !values.fmh_sex.value) {
            errors.fmh_sex = "Sex is required.";
        }

        return errors;
    };

    return (
        <>
            <Formik
                initialValues={{
                    fmh_Status:{ label: "Select Status", value: "Select Status" },
                    relationship:"",
                    fmh_reason:"",
                    fmh_condition:"",
                    fmh_date: "",
                    fmh_sex: "",
                    fmh_contribute_to_death: false,
                    fmh_age: ""
                }}
                validate={validate}
                onSubmit={(values) => {
                    onConfirm((prev) => [
                        ...prev,
                        {
                            type: `FMH ${prev.length + 1}`,
                            data: {
                                resourceType: "FamilyMemberHistory",
                                id:uuidv4(),
                                status: values.fmh_Status.value,
                                relationship: {
                                    text: values.relationship,
                                },
                                reasonCode: {
                                    text: values.fmh_reason
                                },
                                condition: {
                                    code:{
                                        text: values.fmh_condition,
                                    }
                                },
                                sex: values.fmh_sex.value,
                                date: values.fmh_date,
                                contributedToDeath: values.fmh_contribute_to_death,
                                age: values.fmh_age
                            }
                        }
                    ]);
                    close();
                }}
            >
                {({ values, handleSubmit, setFieldValue, handleBlur }) => (
                    <ModalComponent
                        open={open}
                        title={"Add Family Member History"}
                        footerButton={
                            <Button
                                variant={BUTTON_VARIANTS.CONTAINED}
                                onClickCb={handleSubmit}
                            >
                                Submit
                            </Button>
                        }
                        close={() => close()}
                        customClasses="w-[90%] max-w-[800px]"
                        customBodyClasses="overflow-visible" 
                    >
                        <form onSubmit={handleSubmit} className="z-1 flex flex-col gap-4 ">
                            <div className="grid grid-cols-2 gap-4 mt-2">
                                <SelectDropdown
                                    label="Select Status"
                                    isRequired={true}
                                    name="fmh_Status"
                                    customClasses="w-full z-50"
                                    value={values.fmh_Status}
                                    options={[{ label: "Select Status", value: "Select Status" }, ...FAMILY_MEMBER_HISTORY_STATUS]}
                                    onChangeCb={(selectedOption) =>
                                        setFieldValue("fmh_Status", selectedOption)
                                    }
                                />

                                <Input
                                    label="Relationship"
                                    placeholder="Relationship to the subject"
                                    name="relationship"
                                    isRequired={true}
                                    value={values.relationship}
                                    onChangeCb={(e) => setFieldValue("relationship", e.target.value)}
                                    onBlurCb={handleBlur}
                                />
                                 <Input
                                    label="Age"
                                    placeholder="Enter age"
                                    name="fmh_age"
                                    isRequired={true}
                                    value={values.fmh_age}
                                    onChangeCb={(e) => setFieldValue("fmh_age", e.target.value)}
                                />
                                <Input
                                    label="Reason"
                                    placeholder="Enter reason"
                                    name={"fmh_reason"}
                                    isRequired={true}
                                    value={values.fmh_reason}
                                    onChangeCb={(e) => {
                                    setFieldValue("fmh_reason", e.target.value );
                                    }}
                                />
                                <Input
                                    label="Date"
                                    name="fmh_date"
                                    isRequired={true}
                                    type="datetime-local"
                                    value={values.fmh_date}
                                    onChangeCb={(e) => setFieldValue("fmh_date", e.target.value)}
                                />
                                <Input
                                    label="Condition Code"
                                    placeholder="Enter Condition suffered by relation"
                                    name={"fmh_condition"}
                                    isRequired={true}
                                    value={values.fmh_condition}
                                    onChangeCb={(e) => {
                                    setFieldValue("fmh_condition", e.target.value );
                                    }}
                                />
                                <SelectDropdown
                                    label="Sex"
                                    placeholder="Select sex"
                                    isRequired={true}
                                    name="fmh_sex"
                                    customClasses="w-full z-50"
                                    value={values.fmh_sex}
                                    options={[
                                        { label: "Male", value: "male" },
                                        { label: "Female", value: "female" },
                                        { label: "Other", value: "other" },
                                    ]}
                                    onChangeCb={(selectedOption) => setFieldValue("fmh_sex", selectedOption)}
                                />

                                <div className="flex items-center space-x-3 mt-2">
                                <Checkbox
                                    checked={values.fmh_contribute_to_death}
                                    label="Contribute to Death"
                                    name="fmh_contribute_to_death"
                                    onChangeCb={(value) => setFieldValue("fmh_contribute_to_death", value)}
                                    variant="MD"
                                />
                                   
                                </div>
                            </div>
                        </form>
                    </ModalComponent>
                )}
            </Formik>
        </>
    );
};

export default FamilyMemberHistory;
